import * as React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import PublicNav from '../../shared/publicNav';
import styles from './layout.styles';
import Logo from '../../assets/real-sign.svg';

const SignatureLayoutC = ({
  classes,
  children,
}: {
  classes: Object,
  children: React.Element,
}) => (
  <div className={classes.root}>
    <div className={classes.overlay} />

    <PublicNav
      centerLinks={[
        { label: 'Log in', to: '/login' },
      ]}
      actions={
        <Button
          component={Link}
          to="/login"
          variant="outlined"
          size="small"
          className={classes.navSignIn}
        >
          Log in
        </Button>
      }
    />

    <main className={classes.body}>
      <div className={classes.card}>
        <div className={classes.cardLogo}>
          <Logo />
        </div>
        {children}
      </div>
    </main>
  </div>
);

export default withStyles(styles, { withTheme: true })(SignatureLayoutC);
